export enum CardBalanceActionName {
    cardDetails = 'cardDetails',
    freezeCard = 'freezeCard',
    unfreezeCard = 'unfreezeCard',
    getNewCard = 'getNewCard',
    getCard = 'getCard',
    autoExecute = 'autoExecute',
}

export const formatCardNumber = (pan?: string) => {
    if (pan) {
        const v = pan.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        const matches = v.match(/\d{4,19}/g);
        const match = (matches && matches[0]) || '';
        const parts = [];
        for (let i = 0, len = match.length; i < len; i += 4) {
            parts.push(match.substring(i, i + 4));
        }
        if (parts.length) {
            return parts.join(' ');
        }
    }
    return pan;
};

export const getFormatExpirationDate = (expiration?: string) => {
    if (expiration?.length !== 4 || !/^\d+$/.test(expiration)) {
        return expiration;
    }
    const month = expiration.slice(2, 4);
    const yearShort = expiration.slice(0, 2);

    return `${month}/${yearShort}`;
};
